import BaseService from "./BaseService.js";

class LinkedSubjectsService extends BaseService {
  getForm({ module, scope, namespace }) {
    return this.apiGet({
      url: `/${module}/form`,
      params: { namespace, scope },
    });
  }

  getWithModule({ query, signal, module, namespace }) {
    return this.apiGet({
      url: `/${module}/${namespace}`,
      params: query,
      signal,
    });
  }

  getOne({ id, module, signal, namespace }) {
    return this.apiGet({
      url: `/${module}/${namespace}/${id}`,
      signal,
    });
  }

  // needs to adapt to the backend
  getData(query, namespace) {
    return this.apiGet({
      url: `/${namespace}/data`,
      params: query
    });
  }

  // needs to adapt to the backend
  submit(payload, namespace) {
    if (payload.datastakeId) {
      const { datastakeId, id, ...data } = payload;

      return this.apiPut({
        url: `/${payload.module}/initiatives/${datastakeId}`,
        data,
      });
    }

    return this.apiPost({
      url: `/${payload.module}/${namespace}`,
      data: payload,
    });
  }

  remove(id, data, mod, namespace) {
    if (mod) {
      return this.apiDelete({
        url: `/${mod}/${namespace}/${id}`,
        data: data,
      });
    }

    return this.apiDelete({
      url: `/${namespace}/${id}/remove`,
      data: data,
    });
  }

  getLinkedSubjects({ namespace, id, mod }) {
    let _namespace = namespace;

    switch (namespace) {
      case 'location':
        _namespace = 'locations';
        break;
      case 'stakeholder':
        _namespace = 'stakeholders';
        break;
      case 'pictures':
        _namespace = 'documents';
        break;
      default:
    }

    return this.apiGet({
      url: `/${mod}/${_namespace}/${id}/linkedSubjects`,
    });
  }
}

export default new LinkedSubjectsService();
